/*
 * Copyright 2025 Mifos Initiative
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/openMF/mobile-mobile/blob/master/LICENSE.md
 */
package org.mifos.mobile.feature.share.application.di

import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.module
import org.mifos.mobile.feature.share.application.fillApplication.ShareFillApplicationViewModel
import org.mifos.mobile.feature.share.application.shareApplication.ShareApplyViewModel

/**
 * Koin module for the Share Application feature.
 *
 * This module provides the ViewModels required for the share application screens.
 */
val shareApplicationModule = module {
    viewModelOf(::ShareApplyViewModel)
    viewModelOf(::ShareFillApplicationViewModel)
}
